import { render, staticRenderFns } from "./SaleArticlesAttachmentTable.vue?vue&type=template&id=39980e4c&"
import script from "./SaleArticlesAttachmentTable.vue?vue&type=script&lang=js&"
export * from "./SaleArticlesAttachmentTable.vue?vue&type=script&lang=js&"
import style0 from "./SaleArticlesAttachmentTable.vue?vue&type=style&index=0&id=39980e4c&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports